import { IApplicationState } from '../../types/redux';

export const getGeo = (state: IApplicationState) => state.geo;
